import { configureStore } from '@reduxjs/toolkit'
import patientsReducer from './Features/Patient_Scheduling/Patients_Slice';

const store = configureStore({
  reducer: {
    patients: patientsReducer,
  },
});

export default store;